module.exports = __webpack_public_path__ + "static/footer-logo-e073c82e81065fad8b73dcc6a4429734.png";